import { Injectable, inject } from '@angular/core';
import { Boondock, Listing } from '@curbnturf/entities';
import { BoondockApiService } from '../backend-api/boondock-api.service';
import { ListingApiService } from '../backend-api/listing-api.service';
import { Observable } from 'rxjs';

/**
 * NgRx-free replacement for the "dispatch Facade.load(id), poll .selected$"
 * pattern `listing.effects.ts`/`boondock.effects.ts` used to drive detail
 * pages. Calls the same plain backend service methods those effects call on
 * their online branch (the only branch cnt-landing ever exercises — every
 * caller passes a numeric id, never the offline/syncId path) directly, as a
 * single HTTP round trip instead of a dispatch-then-poll-the-store cycle.
 */
@Injectable({ providedIn: 'root' })
export class ListingEntityLookupService {
  private readonly listingSvc = inject(ListingApiService);
  private readonly boondockSvc = inject(BoondockApiService);

  /** Cast to the entity class (not just its `I*` interface) to match what
   *  `toPrivateListingFromEntity`/`toListingDetailFromEntity` expect —
   *  same as what the NgRx path passed them (the raw fetch response was
   *  never actually wrapped in `new Listing(...)` there either). */
  fetchListingById(id: number): Observable<Listing> {
    return this.listingSvc.fetch(id) as unknown as Observable<Listing>;
  }

  fetchBoondockById(id: number): Observable<Boondock> {
    return this.boondockSvc.fetch(id) as unknown as Observable<Boondock>;
  }
}
